// extracted by mini-css-extract-plugin
export default {"AboutPage":"AboutPage_AboutPage__mCfcM"};